import { Component } from '@angular/core';
import { ConstantComponent } from './constant.component';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthGuard } from './shared/guard/auth.guard';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./../styles/app.css']
})
export class AppComponent {
    production: boolean = environment.production;
    staging: string = environment.envName;
    development: string = environment.envName;
    demo: string = environment.envName;

    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    
    constructor(private idle: Idle, private keepalive: Keepalive, private router: Router, private authService: AuthGuard, private sanitizer : DomSanitizer) {
        // localStorage.setItem('inventoryDashboardStatus', 'true');
        // Setting below storage for the Operations Menu to be always open for the USM Service 
        // localStorage.setItem('ModuleIdClick', '4');
        // localStorage.setItem('ModuleIdClick', '173');
        // Overriding below storage for the Super Admin inner Menu to be always open for the USM Service if Sup admin Role
        //if(localStorage.getItem("UserRoleName") == "superadmin"){
            // if(localStorage.getItem('SuperAdminRights') == "true"){
        // if(String(localStorage.getItem("UserRoleName")).toLowerCase() == "superadmin"){
        //     // localStorage.setItem('tyreDashboardStatus', 'true');
        //     localStorage.setItem('ModuleIdClick', '4');
        // }
        // if(String(localStorage.getItem("UserRoleName")).toLowerCase() == "admn"){
        //     // localStorage.setItem('tyreDashboardStatus', 'true');
        //     localStorage.setItem('ModuleIdClick', '173');
        // }

        // sets an idle timeout of 900 seconds(15min), for testing purposes.
        idle.setIdle(900);
        // sets a timeout period of 900 seconds(15min). after 1800 seconds(30min) of inactivity, the user will be considered timed out.
        idle.setTimeout(900);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
        idle.onTimeout.subscribe(() => {
            this.idleState = 'Timed out!';
            this.timedOut = true;
            console.log(this.idleState);
            this.authService.onTokenLoggedout();
            // this.router.navigate(['/login']);
            window.location.href = "/login"
        });
        idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
        idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

        // sets the ping interval to 15 seconds
        keepalive.interval(15);

        //keepalive.onPing.subscribe(() => this.lastPing = new Date());

        this.reset();
        // Production Server
        if (environment.envName === 'prod') {
            ConstantComponent.CloudUrl="https://efleet-usmservice.azurewebsites.net/api";
            ConstantComponent.IframesOfServices=[
                {
                    FE_Url : "ProdUrl for tyre service",
                    id:"ifr_tyre",
                    service:"TYRE",
                    env:environment.envName,
                },
                {
                    FE_Url : "ProdUrl for MDM Module",
                    id:"ifr_mdm",
                    service:"MDM",
                    env:environment.envName,
                }
            ]
            ConstantComponent.CloudPort="";
            ConstantComponent.CloudReportUrl="";
            ConstantComponent.CloudSSRSReportUrl="";
            // ConstantComponent.url = 'https://stagingapi.efleetsystems.com/api';
            ConstantComponent.url = 'https://--Missing-Api--';
            ConstantComponent.port = 'https://stagingapi.efleetsystems.com';
            // ConstantComponent.reportUrl = 'http://139.59.37.161:8080';
            ConstantComponent.reportUrl = 'http://apiprod.efleetsystems.com:8080/EFleetReports';
            ConstantComponent.SSRSReportUrl = 'https://mistcloudreports.efleetsystems.com';
        }
        //Development Test Server
        else if(environment.envName === "dev") {
            ConstantComponent.CloudUrl="https://efleet-uslservice.azurewebsites.net/api";
            ConstantComponent.TyreCloudUrl = "https://efleet-tyreservice.azurewebsites.net/api";
            ConstantComponent.CNCloudUrl = "https://efleet-digitalcnservice.azurewebsites.net/api";
            ConstantComponent.IframesOfServices=[
                {
                    // FE_Url : "https://efleetwebappfe.z29.web.core.windows.net",
                    FE_Url : "https://devefleettyreimpact.z30.web.core.windows.net",
                    id:"ifr_tyre",
                    service:"TYRE",
                    env:environment.envName,
                },
                {
                    // FE_Url : "https://efleetmdmdev.z10.web.core.windows.net",
                    FE_Url : "https://devefleetmdmimpact.z30.web.core.windows.net",
                    id:"ifr_mdm",
                    service:"MDM",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://efleetdevcn.z29.web.core.windows.net",
                    id:"ifr_cn",
                    service:"CN",
                    env:environment.envName,
                }
            ]
            // ConstantComponent.url = 'https://--Missing-Api--';
            ConstantComponent.url = 'https://--Missing-Api--';
        }
        // QA Test Server
        else if(environment.envName === "qa") {
            ConstantComponent.CloudUrl="https://efleet-uslservice-qa.azurewebsites.net/api";
            ConstantComponent.TyreCloudUrl = "https://efleet-qa-tyreservice.azurewebsites.net/api"
            ConstantComponent.CNCloudUrl = "https://efleet-digitalcnservice-qa.azurewebsites.net/api";
            ConstantComponent.IframesOfServices=[
                {
                    FE_Url : "https://efleetwebappfetest.z29.web.core.windows.net",
                    id:"ifr_tyre",
                    service:"TYRE",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://qaefleetmdm.z29.web.core.windows.net",
                    id:"ifr_mdm",
                    service:"MDM",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://efleetqacn.z29.web.core.windows.net",
                    id:"ifr_cn",
                    service:"CN",
                    env:environment.envName,
                }
            ]
            // ConstantComponent.url = 'https://qaapiv2.efleetsystems.com/api';
            ConstantComponent.url = 'https://--Missing-Api--';
        }
        // UAT Test Server
        else if(environment.envName === "uat") {
            ConstantComponent.CloudUrl="https://efleet-uslservice-uat.azurewebsites.net/api";
            ConstantComponent.TyreCloudUrl = "https://uat-efleettyreservice.azurewebsites.net/api";
            ConstantComponent.IframesOfServices=[
                {
                    // FE_Url : "https://efleettyreuat.z29.web.core.windows.net", 
                    FE_Url : "https://uattyre.efleetsystems.com", 
                    id:"ifr_tyre",
                    service:"TYRE",
                    env:environment.envName,
                },
                {
                    // FE_Url : "https://uatefleetmdm.z29.web.core.windows.net",
                    FE_Url : "https://uatmdm.efleetsystems.com",
                    id:"ifr_mdm",
                    service:"MDM",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://uatconsignment.efleetsystems.com",
                    id:"ifr_cn",
                    service:"CN",
                    env:environment.envName,
                }
            ]
            // ConstantComponent.url = 'https://qaapiv2.efleetsystems.com/api';
            ConstantComponent.url = 'https://--Missing-Api--';
        }
        //Local Test Server
        else {
            ConstantComponent.CloudUrl="https://efleet-uslservice.azurewebsites.net/api";
            ConstantComponent.TyreCloudUrl = "https://efleet-tyreservice.azurewebsites.net/api";
            ConstantComponent.CNCloudUrl = "https://efleet-digitalcnservice.azurewebsites.net/api";
            ConstantComponent.IframesOfServices=[
                {
                    FE_Url : "https://efleetwebappfe.z29.web.core.windows.net",
                    id:"ifr_tyre",
                    service:"TYRE",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://efleetmdmdev.z10.web.core.windows.net",
                    id:"ifr_mdm",
                    service:"MDM",
                    env:environment.envName,
                },
                {
                    FE_Url : "https://efleetdevcn.z29.web.core.windows.net",
                    id:"ifr_cn",
                    service:"CN",
                    env:environment.envName,
                }
            ]
            // ConstantComponent.url = 'https://tmsapi.efleetsystems.com/api';
            ConstantComponent.url = 'https://--Missing-Api--';
        }
        this.services = ConstantComponent.IframesOfServices.map((service:any)=>{
            return {...service,FE_Url : this.sanitizer.bypassSecurityTrustResourceUrl(service.FE_Url + "/assets/cross_domain_store.html") }
            // return {...service,FE_Url : this.sanitizer.bypassSecurityTrustResourceUrl(service.FE_Url + "/") }// this will load whole website and bundles.
        })
        console.log(environment.envName);
        ConstantComponent.ModuleDetailsWithURLS = [
            {
                moduleDetailsId : 13,
                moduleName:"TYRE",
                URL:ConstantComponent.IframesOfServices.filter((item=>item.service == 'TYRE'))[0].FE_Url,
                envName:environment.envName
            },
            {
                moduleDetailsId : 4,
                moduleName:"CN",
                URL:ConstantComponent.IframesOfServices.filter((item=>item.service == 'CN'))[0].FE_Url,
                envName:environment.envName
            }
        ]
    }
    services=ConstantComponent.IframesOfServices;
    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }
}
